export default __webpack_public_path__ + "static/media/ProductSans-Thin.53bfdff5.svg";